import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import styled from 'styled-components';
import Carousel from 're-carousel';
import { remCalc } from '@lux/helpers';

const Wrapper = styled.div`
  height: ${p => remCalc(p.height)};
`;

const Frame = styled.div`
  background-color: ${p => p.theme.colours.white};
`;

const StyledCarousel = styled(props => <Carousel {...props} />)`
  text-align: center;
  margin-bottom: ${p => p.theme.spacing(2)};
`;

const StyledDots = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin: ${p => p.theme.spacing(2)} 0;
`;

const StyledDot = styled.div`
  height: ${p => p.theme.spacing(1)};
  width: ${p => p.theme.spacing(1)};
  border-radius: 50%;
  margin: ${p => p.theme.spacing(0.5)};
  text-align: center;
  background: ${p =>
    p.filled ? p.theme.colours.nearBlack : p.theme.colours.grey_e1};
`;

const Dots = props => {
  const { index, total } = props;

  return (
    <StyledDots>
      {Array.apply(null, Array(total)).map((_, key) => (
        <StyledDot key={key} filled={index === key} />
      ))}
    </StyledDots>
  );
};

Dots.propTypes = {
  index: PropTypes.number,
  tatal: PropTypes.number
};

const PhoneImageCarousel = props => {
  const { height, imageGallery, title } = props;
  const { images = [] } = imageGallery;

  const Frames = images
    .filter(({ image }) => image && image.childImageSharp)
    .map(({ image }) => (
      <Frame key={image.id}>
        <Img
          image={image.childImageSharp.gatsbyImageData}
          alt={title}
          loading="lazy"
          style={{ width: 200, height: 200 }}
        />
      </Frame>
    ));

  return (
    <Wrapper height={height} data-testid={imageGallery.name}>
      <StyledCarousel loop={true} widgets={[Dots]} frames={Frames} />
    </Wrapper>
  );
};

PhoneImageCarousel.defaultProps = {
  height: 200,
  imageGallery: [],
  title: ''
};

PhoneImageCarousel.propTypes = {
  /** Height of Carousel in pixels */
  height: PropTypes.number,
  /** Image gallery object */
  imageGallery: PropTypes.shape({
    name: PropTypes.string,
    hexCode: PropTypes.string,
    images: PropTypes.array
  }),
  /** Title of image gallery */
  title: PropTypes.string
};

export default PhoneImageCarousel;
